import { GetProductsRequestPost } from './products.interface';

export class ProductsUtils {
    static readonly placeholderImageSrc = '/assets/ca-images/placeholder.png';
    static readonly defaultPageSize = 20;
    static readonly defaultCountryCode: GetProductsRequestPost['countryCode'] = 'DE';
    static readonly defaultLanguageCode: GetProductsRequestPost['languageCode'] = 'de';
    static readonly defaultIncludeMarketingFormattedTexts = true;
}
